function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash/fp';
import Ncs from '../index';

var fp = _.noConflict();

var reduceWithKeys = fp.reduce.convert({
  cap: false
});
var eachWithKeys = fp.each.convert({
  cap: false
});
var everyWithKeys = fp.every.convert({
  cap: false
});

var isBlank = function isBlank(e) {
  return fp.isEmpty(e) && !fp.isBoolean(e) && !fp.isNumber(e) || fp.isNaN(e);
};

function resetDependent(id, state) {
  var dependent = fp.filter(function (f) {
    return fp.includes(id)(f.dependencies);
  })(state.byId);
  fp.each(function (f) {
    return f.value = f.default;
  })(dependent);
}

function combinations(field, dependencies) {
  if (fp.isEmpty(dependencies)) {
    return [];
  }

  return Ncs.config.filters.dependency_values[field];
}

function _possibleValues(id, state) {
  var filter = state.byId[id];

  if (!filter) {
    return [];
  }

  var dependencyFilters = fp.pickBy(function (v, k) {
    // Pick result should include __ob__ property to allow vue to detect changes.
    var isObserver = k === '__ob__';
    var isParent = fp.includes(k)(filter.dependencies);
    var hasValue = !fp.isNil(v.value) && !fp.isArray(v.value) || fp.isArray(v.value) && v.value.length > 0;
    return isObserver || isParent && hasValue;
  })(state.byId);

  if (fp.isEmpty(dependencyFilters)) {
    return filter.values;
  }

  var match = fp.reduce(function (r, f) {
    return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, f.field, f.value));
  })({})(dependencyFilters);
  var values = fp.pipe(fp.filter(function (c) {
    return everyWithKeys(function (v, f) {
      return fp.includes(c[f], v);
    }, match);
  }), fp.map(filter.field), fp.uniq)(filter.combinations); // Intersection removes invalid values preserving their original order

  return fp.intersection(filter.values, values);
}

export default {
  namespaced: true,
  state: {
    byId: {}
  },
  mutations: {
    addFilter: function addFilter(s, options) {
      if (s.byId[options.id]) {
        throw "Filter with id \"".concat(options.id, "\" already exists");
      }

      s.byId = _objectSpread(_objectSpread({}, s.byId), {}, _defineProperty({}, options.id, {
        default: options.default,
        field: options.field,
        operator: options.operator,
        value: options.value || options.default,
        disabled: options.disabled,
        values: Ncs.config.filters.values[options.field] || [],
        dependencies: options.dependencies || [],
        combinations: combinations(options.field, options.dependencies, s)
      }));
      resetDependent(options.id, s);
    },
    setDisabled: function setDisabled(s, _ref) {
      var id = _ref.id,
          disabled = _ref.disabled;
      return s.byId[id] ? s.byId[id].disabled = disabled : null;
    },
    setFilter: function setFilter(s, filters) {
      eachWithKeys(function (v, id) {
        if (!s.byId[id]) {
          return;
        }

        s.byId[id].value = v;
        resetDependent(id, s);
      })(filters);
    },
    // Set the filter values if they are more strict than the ones already set
    setFilterIfMoreStrict: function setFilterIfMoreStrict(s, filters) {
      eachWithKeys(function (v, f) {
        var isNumber = !fp.isNaN(Number(v));

        if (!isNumber) {
          s.byId[f].value = v;
        } else {
          v = Number(v);
          var isLtFilter = s.byId[f].operator === 'lt' || s.byId[f].operator === 'lteq';
          var isGtFilter = s.byId[f].operator === 'gt' || s.byId[f].operator === 'gteq';
          var isMoreStrict = !s.byId[f].value || isLtFilter && v < s.byId[f].value || isGtFilter && v > s.byId[f].value;

          if (isMoreStrict) {
            s.byId[f].value = v;
          }
        }
      })(filters);
    },
    reset: function reset(s) {
      return fp.each(function (f) {
        return f.value = f.default;
      })(s.byId);
    },
    resetElementFilters: function resetElementFilters(s, element) {
      return fp.pipe(fp.filter(function (f) {
        return f.field.match(new RegExp("^ncs_".concat(element, "\\.")));
      }), fp.each(function (f) {
        return f.value = f.default;
      }))(s.byId);
    },
    resetFilter: function resetFilter(s, id) {
      return s.byId[id].value = s.byId[id].default;
    },
    restoreSnapshot: function restoreSnapshot(s, v) {
      return eachWithKeys(function (e, id) {
        return s.byId[id].value = e;
      })(v);
    }
  },
  getters: {
    exists: function exists(s) {
      return function (id) {
        return typeof s.byId[id] !== 'undefined';
      };
    },
    // Return an object with the current filters
    selectedValue: function selectedValue(s) {
      return function (id) {
        return fp.getOr(null, 'value', s.byId[id]);
      };
    },
    isDisabled: function isDisabled(s) {
      return function (id) {
        return fp.getOr(null, 'disabled', s.byId[id]);
      };
    },
    // Get the array of dependencies of the provided filter
    dependencies: function dependencies(s) {
      return function (id) {
        return fp.map('value')(fp.pick(fp.getOr([], 'dependencies', s.byId[id]))(s));
      };
    },
    // Get the possible options after filtering by the provided filter and their dependencies
    possibleValues: function possibleValues(s) {
      return function (id) {
        return _possibleValues(id, s);
      };
    },
    maxValue: function maxValue(s) {
      return function (id) {
        return s.byId[id] ? fp.max(s.byId[id].values) : null;
      };
    },
    minValue: function minValue(s) {
      return function (id) {
        return s.byId[id] ? fp.min(s.byId[id].values) : null;
      };
    },
    // Returns true if every parent of the provided filter has a value or there are no parents.
    parentsEmpty: function parentsEmpty(s) {
      return function (id) {
        return s.byId[id] ? fp.every(function (p) {
          return fp.isNil(s.byId[p].value);
        })(s.byId[id].dependencies) : null;
      };
    },
    snapshot: function snapshot(s) {
      return reduceWithKeys(function (r, f, id) {
        return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, id, f.value));
      })({})(s.byId);
    },
    query: function query(s) {
      var isValidFilter = function isValidFilter(id) {
        return !isBlank(s.byId[id].value) && !s.byId[id].disabled;
      };

      var formatFilter = function formatFilter(id) {
        return {
          name: s.byId[id].field,
          value: s.byId[id].value,
          operator: s.byId[id].operator
        };
      };

      var appendValidFilter = function appendValidFilter(r, _v, id) {
        return isValidFilter(id) ? [].concat(_toConsumableArray(r), [formatFilter(id)]) : r;
      };

      return reduceWithKeys(appendValidFilter, [])(s.byId);
    }
  },
  actions: {
    reset: function reset(_ref2) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          getters = _ref2.getters;
      commit('reset');
    },
    // Reset all filters that are defined over an element.
    resetElementFilters: function resetElementFilters(_ref3, element) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          getters = _ref3.getters;
      fp.pipe(fp.keys, fp.filter(function (id) {
        return state.byId[id].field.match(new RegExp("^ncs_".concat(element, "\\.")));
      }), fp.each(function (id) {
        return commit('resetFilter', id);
      }))(state.byId);
    }
  }
};